export const NoInteractionWaitingPlaceholderIcon = () => {
	return (
		<svg
			width="112"
			height="47"
			viewBox="0 0 112 47"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_11345_32916)">
				<rect x="8" y="10" width="102" height="34" rx="4" fill="#EBEBEB" />
			</g>
			<g filter="url(#filter1_d_11345_32916)">
				<rect width="102" height="34" rx="4" fill="#F5F5F5" />
			</g>
			<circle
				cx="7"
				cy="7"
				r="7"
				transform="matrix(-1 0 0 1 22 10)"
				fill="white"
			/>
			<path
				d="M31 13H87"
				stroke="#D1D1D1"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M31 21H87"
				stroke="#D1D1D1"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<defs>
				<filter
					id="filter0_d_11345_32916"
					x="8"
					y="10"
					width="104"
					height="37"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx="2" dy="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_11345_32916"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_11345_32916"
						result="shape"
					/>
				</filter>
				<filter
					id="filter1_d_11345_32916"
					x="0"
					y="0"
					width="104"
					height="37"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx="2" dy="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_11345_32916"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_11345_32916"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
